import React from "react";
import { Link } from "react-router-dom";
import blogs from '../../api/blogs'
import styles from './BlogSectionS2.module.css'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSectionS2 = (props) => {





    return (
        <section className="wpo-blog-section-s2 section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-12">
                        <div className="wpo-section-title">
                            <span>- TIN TỨC MỚI -</span>
                            <h2>Tin tức và bài viết mới nhất của chúng tôi.</h2>
                            <Link className="theme-btn" to="/blog">Các bài đăng khác</Link>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {blogs.slice(0, 3).map((blog, bl) => (
                        <div className="col-lg-4 col-md-6 col-12" key={bl}>
                            <div className={`blog-single-card ${styles.serviceCardWrapper}`} >
                                <div className="image">
                                    <img src={blog.screens} alt="" />
                                </div>
                                <div className="content">
                                    <span>{blog.create_at}</span>
                                    <h3>{blog.title}</h3>
                                    <p>{blog.subtitle}</p>
                                </div>
                                <Link className="theme-btn" onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>Xem Thêm</Link>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>



    );
}

export default BlogSectionS2;










